export function showThankyouMessage() {
	$('#header-text').text('Thank you for choosing a Bark credit subscription');
	$('#subheader-text').remove();
	$('#cta-container').remove();
	$('#cs-packages').remove();
	$('#whychoose-container').remove();
	$('#faq-container').remove();
	$('#contact-cs-help-text').text('To manage your subscription');
	setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 500);
}
